import React from "react";
import {
  Users,
  BookOpen,
  FileText,
  Award,
  Globe,
  CheckCircle2,
  LucideIcon,
} from "lucide-react";
import BMTeacher from "../../assets/teacher/SPM/Cikgu Winnie Lee_BM.jpg";
import ENTeacher from "../../assets/teacher/SPM/Ms. Suarnah_BI.jpg";
import SejTeacher from "../../assets/teacher/SPM/Cikgu Chew_Sej.jpg";
import MathTeacher from "../../assets/teacher/SPM/Mr Tan_Math.jpg";
import ChemTeacher from "../../assets/teacher/SPM/Mr Ryan_Chem.png";
import PhyTeacher from "../../assets/teacher/SPM/Mr Kanvin_Phy.jpg";

export interface BenefitCardProps {
  icon: LucideIcon;
  title: string;
  desc: string;
}

export const WA_NUMBER = "60179889559";
export const WA_LINK = `https://wa.me/${WA_NUMBER}`;
export const WA_COMMUNITY_BM =
  "https://chat.whatsapp.com/KLVvfzGRCOxICuxZ6EdL8n";
export const WA_COMMUNITY_BC =
  "https://chat.whatsapp.com/LcROfpLbreDHB44K8SWEja";

export const DARK = "#0A2218";

const svgProps = {
  viewBox: "0 0 40 40",
  fill: "none",
  className: "w-full h-full",
};

export const SUBJECT_ICONS: Record<string, React.ReactElement> = {
  "Bahasa Melayu": React.createElement(
    "svg",
    svgProps,
    React.createElement("rect", {
      x: 7,
      y: 5,
      width: 20,
      height: 26,
      rx: 3,
      stroke: "white",
      strokeWidth: 1.5,
      fill: "white",
      fillOpacity: 0.15,
    }),
    React.createElement("line", {
      x1: 11,
      y1: 12,
      x2: 23,
      y2: 12,
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 11,
      y1: 17,
      x2: 23,
      y2: 17,
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 11,
      y1: 22,
      x2: 18,
      y2: 22,
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
    }),
    React.createElement("path", {
      d: "M27 26 C27 22 32 20 32 16 C32 13 30 11 28 11",
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      fill: "none",
      fillOpacity: 0.6,
    }),
    React.createElement("circle", {
      cx: 29,
      cy: 10,
      r: 1.5,
      fill: "white",
      fillOpacity: 0.6,
    }),
  ),
  English: React.createElement(
    "svg",
    svgProps,
    React.createElement("path", {
      d: "M8 8 H32 Q34 8 34 10 V24 Q34 26 32 26 H22 L16 32 L16 26 H10 Q8 26 8 24 V10 Q8 8 10 8 Z",
      stroke: "white",
      strokeWidth: 1.5,
      fill: "white",
      fillOpacity: 0.12,
    }),
    React.createElement(
      "text",
      {
        x: 21,
        y: 21,
        textAnchor: "middle",
        fill: "white",
        fontSize: 10,
        fontWeight: "bold",
        fontFamily: "serif",
      },
      "ABC",
    ),
  ),
  Sejarah: React.createElement(
    "svg",
    svgProps,
    React.createElement("path", {
      d: "M12 6 C12 6 10 8 10 10 L10 32 C10 34 12 34 12 34 L30 34 C32 34 32 32 32 32 L32 10 C32 8 30 6 30 6 Z",
      stroke: "white",
      strokeWidth: 1.5,
      fill: "white",
      fillOpacity: 0.12,
    }),
    React.createElement("path", {
      d: "M8 8 C8 8 10 10 12 10 C14 10 16 6 18 6",
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      fill: "none",
    }),
    React.createElement("line", {
      x1: 15,
      y1: 14,
      x2: 27,
      y2: 14,
      stroke: "white",
      strokeWidth: 1.2,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 15,
      y1: 19,
      x2: 27,
      y2: 19,
      stroke: "white",
      strokeWidth: 1.2,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 15,
      y1: 24,
      x2: 22,
      y2: 24,
      stroke: "white",
      strokeWidth: 1.2,
      strokeLinecap: "round",
    }),
  ),
  Mathematics: React.createElement(
    "svg",
    svgProps,
    React.createElement("line", {
      x1: 6,
      y1: 34,
      x2: 34,
      y2: 34,
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 6,
      y1: 6,
      x2: 6,
      y2: 34,
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
    }),
    React.createElement("path", {
      d: "M6 28 Q12 10 20 20 Q28 30 34 8",
      stroke: "white",
      strokeWidth: 2,
      strokeLinecap: "round",
      fill: "none",
    }),
    React.createElement("circle", { cx: 20, cy: 20, r: 2, fill: "white" }),
  ),
  "Additional Mathematics": React.createElement(
    "svg",
    svgProps,
    React.createElement("line", {
      x1: 6,
      y1: 34,
      x2: 34,
      y2: 34,
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 6,
      y1: 6,
      x2: 6,
      y2: 34,
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
    }),
    React.createElement("path", {
      d: "M6 30 C10 30 12 10 18 10 C22 10 22 22 26 18 C30 14 32 22 34 18",
      stroke: "white",
      strokeWidth: 2,
      strokeLinecap: "round",
      fill: "none",
    }),
    React.createElement(
      "text",
      {
        x: 33,
        y: 12,
        fill: "white",
        fontSize: 8,
        fontWeight: "bold",
        fillOpacity: 0.9,
      },
      "∫",
    ),
  ),
  Chemistry: React.createElement(
    "svg",
    svgProps,
    React.createElement("path", {
      d: "M15 6 L15 18 L8 32 Q7 34 9 34 L31 34 Q33 34 32 32 L25 18 L25 6 Z",
      stroke: "white",
      strokeWidth: 1.5,
      fill: "white",
      fillOpacity: 0.12,
    }),
    React.createElement("line", {
      x1: 13,
      y1: 10,
      x2: 27,
      y2: 10,
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
    }),
    React.createElement("circle", {
      cx: 14,
      cy: 27,
      r: 2,
      fill: "white",
      fillOpacity: 0.6,
    }),
    React.createElement("circle", {
      cx: 22,
      cy: 24,
      r: 1.5,
      fill: "white",
      fillOpacity: 0.4,
    }),
    React.createElement("circle", {
      cx: 27,
      cy: 29,
      r: 2.5,
      fill: "white",
      fillOpacity: 0.5,
    }),
  ),
  Physics: React.createElement(
    "svg",
    svgProps,
    React.createElement("circle", { cx: 20, cy: 20, r: 3, fill: "white" }),
    React.createElement("ellipse", {
      cx: 20,
      cy: 20,
      rx: 13,
      ry: 5,
      stroke: "white",
      strokeWidth: 1.5,
      fill: "none",
    }),
    React.createElement("ellipse", {
      cx: 20,
      cy: 20,
      rx: 13,
      ry: 5,
      stroke: "white",
      strokeWidth: 1.5,
      fill: "none",
      transform: "rotate(60 20 20)",
    }),
    React.createElement("ellipse", {
      cx: 20,
      cy: 20,
      rx: 13,
      ry: 5,
      stroke: "white",
      strokeWidth: 1.5,
      fill: "none",
      transform: "rotate(120 20 20)",
    }),
  ),
};

const stepSvgProps = {
  viewBox: "0 0 80 80",
  fill: "none",
  className: "w-full h-full",
};

export const STEP_ILLUSTRATIONS: React.ReactElement[] = [
  React.createElement(
    "svg",
    { key: "s1", ...stepSvgProps },
    React.createElement("rect", {
      x: 12,
      y: 10,
      width: 48,
      height: 56,
      rx: 6,
      fill: "#E0F2FE",
      stroke: "#0EA5E9",
      strokeWidth: 2,
    }),
    React.createElement("line", {
      x1: 22,
      y1: 26,
      x2: 50,
      y2: 26,
      stroke: "#0EA5E9",
      strokeWidth: 2,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 22,
      y1: 34,
      x2: 50,
      y2: 34,
      stroke: "#0EA5E9",
      strokeWidth: 2,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 22,
      y1: 42,
      x2: 38,
      y2: 42,
      stroke: "#0EA5E9",
      strokeWidth: 2,
      strokeLinecap: "round",
    }),
    React.createElement("circle", { cx: 58, cy: 58, r: 14, fill: "#0EA5E9" }),
    React.createElement("path", {
      d: "M52 58 L56 62 L64 54",
      stroke: "white",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }),
  ),
  React.createElement(
    "svg",
    { key: "s2", ...stepSvgProps },
    React.createElement("rect", {
      x: 14,
      y: 8,
      width: 38,
      height: 64,
      rx: 6,
      fill: "#E0F2FE",
      stroke: "#0EA5E9",
      strokeWidth: 2,
    }),
    React.createElement("rect", {
      x: 19,
      y: 14,
      width: 28,
      height: 44,
      rx: 3,
      fill: "white",
    }),
    React.createElement("circle", { cx: 33, cy: 66, r: 3, fill: "#0EA5E9" }),
    React.createElement("circle", { cx: 50, cy: 38, r: 16, fill: "#25D366" }),
    React.createElement("path", {
      d: "M44 32 C44 32 46 30 50 30 C57 30 62 35 62 41 C62 47 57 52 50 52 C48 52 46 51.5 44 50.5 L38 52 L39.5 46 C38 44 37 42 37 41 C37 35 40 32 44 32 Z",
      fill: "white",
    }),
    React.createElement("path", {
      d: "M44 38 C44 36 47 34 50 34 C53 34 56 36 56 38",
      stroke: "#25D366",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      fill: "none",
    }),
  ),
  React.createElement(
    "svg",
    { key: "s3", ...stepSvgProps },
    React.createElement("rect", {
      x: 10,
      y: 18,
      width: 60,
      height: 38,
      rx: 5,
      fill: "#E0F2FE",
      stroke: "#0EA5E9",
      strokeWidth: 2,
    }),
    React.createElement("rect", {
      x: 16,
      y: 24,
      width: 48,
      height: 26,
      rx: 3,
      fill: "white",
    }),
    React.createElement("line", {
      x1: 30,
      y1: 62,
      x2: 50,
      y2: 62,
      stroke: "#0EA5E9",
      strokeWidth: 2,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 40,
      y1: 56,
      x2: 40,
      y2: 62,
      stroke: "#0EA5E9",
      strokeWidth: 2,
    }),
    React.createElement("circle", { cx: 40, cy: 37, r: 10, fill: "#0EA5E9" }),
    React.createElement("polygon", {
      points: "37,33 37,41 46,37",
      fill: "white",
    }),
  ),
  React.createElement(
    "svg",
    { key: "s4", ...stepSvgProps },
    React.createElement("rect", {
      x: 12,
      y: 12,
      width: 56,
      height: 44,
      rx: 5,
      fill: "#E0F2FE",
      stroke: "#0EA5E9",
      strokeWidth: 2,
    }),
    React.createElement("line", {
      x1: 40,
      y1: 12,
      x2: 40,
      y2: 56,
      stroke: "#0EA5E9",
      strokeWidth: 1.5,
      strokeOpacity: 0.4,
    }),
    React.createElement("path", {
      d: "M20 24 L30 24 L30 44 L20 44 Z",
      fill: "#0EA5E9",
      fillOpacity: 0.3,
      stroke: "#0EA5E9",
      strokeWidth: 1.5,
    }),
    React.createElement("path", {
      d: "M44 30 L60 30 L60 44 L44 44 Z",
      fill: "#0EA5E9",
      fillOpacity: 0.15,
      stroke: "#0EA5E9",
      strokeWidth: 1.5,
    }),
    React.createElement("line", {
      x1: 46,
      y1: 34,
      x2: 58,
      y2: 34,
      stroke: "#0EA5E9",
      strokeWidth: 1.2,
      strokeLinecap: "round",
    }),
    React.createElement("line", {
      x1: 46,
      y1: 38,
      x2: 58,
      y2: 38,
      stroke: "#0EA5E9",
      strokeWidth: 1.2,
      strokeLinecap: "round",
    }),
    React.createElement("path", {
      d: "M22 66 L36 66",
      stroke: "#0EA5E9",
      strokeWidth: 2,
      strokeLinecap: "round",
    }),
    React.createElement("path", {
      d: "M44 66 L58 66",
      stroke: "#0EA5E9",
      strokeWidth: 2,
      strokeLinecap: "round",
    }),
    React.createElement("circle", { cx: 18, cy: 68, r: 4, fill: "#10B981" }),
    React.createElement("path", {
      d: "M16 68 L17.5 69.5 L20 66.5",
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }),
  ),
];

export const BENEFITS: BenefitCardProps[] = [
  {
    icon: CheckCircle2,
    title: "100% Free",
    desc: "All the revision materials and learning resources are provided completely free of charge.",
  },
  {
    icon: FileText,
    title: "SPM Revision Notes",
    desc: "Get revision notes prepared by Guru Cemerlang & Textbook Authors to help you focus on important topics",
  },
  {
    icon: Award,
    title: "Exam Tips & Scoring Strategies",
    desc: "Learn useful exam tips and answering techniques to help you understand how to answer questions and score better.",
  },
  {
    icon: Users,
    title: "Prepared by Guru Cemerlang & Textbook Author",
    desc: "Get revision materials and guidance prepared by experienced Guru Cemerlang and Textbook Author, with years of teaching and examination experience.",
  },
  {
    icon: BookOpen,
    title: "Recorded Teacher Guidance Videos",
    desc: "Our teachers have prepared recorded videos to guide you on: How to use the revision notes, revise more effectively, what to focus on during revision and how to approach examination questions and score",
  },

  {
    icon: Globe,
    title: "Learn at Your Own Pace",
    desc: "Access the revision notes, exam tips, and recorded videos through our online learning portal anytime, anywhere.",
  },
];

export const PAIN_POINTS = [
  {
    pain: "Not Sure What to Revise?",
    desc: "Too many chapters and no idea where to begin.",
    solution:
      "Get revision notes and important topics that help you focus your preparation.",
  },
  {
    pain: "Not Enough Time to Revise?",
    desc: "Worried you won't have enough time before SPM.",
    solution:
      "Study at your own pace through the online portal and revisit recorded lessons whenever you need.",
  },
  {
    pain: "Know the Answer but Still Lose Marks?",
    desc: "You understand the topic but can't structure answers effectively.",
    solution:
      "Learn practical answering techniques, exam tips, and scoring strategies from experienced teachers.",
  },
  {
    pain: "Studying Hard but Still Not Confident?",
    desc: "You've been revising but still feel unsure about your preparation.",
    solution:
      "Strengthen your understanding with structured revision materials and teacher-guided lessons.",
  },
];

export const SUBJECTS = [
  { name: "Bahasa Melayu", color: "#DC2626", teacher: "Cikgu Winnie Lee" },
  { name: "English", color: "#7C3AED", teacher: "Ms. Suarnah" },
  { name: "Sejarah", color: "#B45309", teacher: "Cikgu Chew" },
  { name: "Mathematics", color: "#1D4ED8", teacher: "Mr Tan" },
  { name: "Additional Mathematics", color: "#0369A1", teacher: "Mr Tan" },
  { name: "Chemistry", color: "#047857", teacher: "Mr Ryan" },
  { name: "Physics", color: "#4338CA", teacher: "Mr Kanvin" },
];

export const TEACHERS = [
  {
    id: "spm_teacher_bm",
    name: "Cikgu Winnie Lee",
    subject: "Bahasa Melayu",
    avatar: BMTeacher,
    color: "#DC2626",
    credentials: [
      "Postgraduate Diploma in Education — Bahasa Melayu",
      "Bachelor's Degree in Malay Language and Linguistics",
      "Master of Education in Curriculum Studies — Bahasa Melayu",
      "More than 19 years of teaching experience",
      "Currently teaching at SMK Air Itam, Penang",
      "Author with Penerbit Ilmu Bakti and Penerbit Cemerlang",
    ],
  },
  {
    id: "spm_teacher_en",
    name: "Ms. Suarnah",
    subject: "English",
    avatar: ENTeacher,
    color: "#7C3AED",
    credentials: [
      "Bachelor of Arts (Hons) in English Language — UTAR",
      "Master of Education — MSU",
      "120-Hour TEFL/TESOL Certificate",
      "Certificate in English Language Teaching — Secondary (CELT-S)",
      "English Language Educator at Hin Hua High School",
    ],
  },
  {
    id: "spm_teacher_sej",
    name: "Cikgu Chew",
    subject: "Sejarah",
    avatar: SejTeacher,
    color: "#B45309",
    credentials: [
      "University of Malaya alumnus",
      "More than 20 years of experience teaching Bahasa Melayu and Sejarah for SPM",
      "Head Tutor at Arif Maju Tuition Center, Kulai",
      "Speaker for SCS Education's Sejarah Ultimate Revision Class",
    ],
  },
  {
    id: "spm_teacher_math",
    name: "Mr Tan",
    subject: "Mathematics & Add. Maths",
    avatar: MathTeacher,
    color: "#1D4ED8",
    credentials: [
      "First-Class Degree in Mathematics, Universiti Malaya",
      "10 years of teaching experience",
      "SPM and IGCSE examination workshop speaker",
      "Recipient of the National Outstanding Educator Award 2023",
      "Recipient of the Prestigious Teacher Award 2023",
    ],
  },
  {
    id: "spm_teacher_chem",
    name: "Mr Ryan",
    subject: "Chemistry",
    avatar: ChemTeacher,
    color: "#047857",
    credentials: [
      "Bachelor of Science — Universiti Sains Malaysia",
      "EDUFLUENCERS 4.0 · Guru Cemerlang Tingkatan 6 for Chemistry",
      "15 years of teaching experience",
      "Author of STPM Chemistry Semester 1",
      "Has helped more than 200 students achieve an A",
    ],
  },
  {
    id: "spm_teacher_phy",
    name: "Mr Kanvin",
    subject: "Physics",
    avatar: PhyTeacher,
    color: "#4338CA",
    credentials: [
      "17 years of teaching experience",
      "Founder of AZ Smart Learning Centre",
      "Youngest Malaysia Influential Educator 2023",
      "Keynote Speaker at UM, Sunway & HighSchool_my SPM Seminars",
      "Has helped more than 800 students achieve excellent results",
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Liew Xin Yi",
    role: "SPM Student",
    stars: 5,
    text: "I used to struggle with Chemistry and was always stuck at a B. After joining the online revision class, the teacher helped me identify the important topics and showed me how to avoid common mistakes that cost marks. I was really happy with my results!",
  },
  {
    name: "Chong Kai Jie",
    role: "SPM Student",
    stars: 5,
    text: "I wasn't very confident in Mathematics and initially just wanted to pass. The teacher explained everything in a simple and easy-to-understand way. In the end, I achieved a B, which was better than I expected. I'm really thankful for the guidance.",
  },
  {
    name: "Lim Jia Yang",
    role: "SPM Student",
    stars: 5,
    text: "The lessons were interesting and easy to understand. The teacher showed us which topics to focus on and how to revise more effectively. It made my revision much easier and helped me save a lot of time.",
  },
  {
    name: "Ms. Zhuang",
    role: "English Teacher",
    stars: 5,
    text: "After participating in SCS Education's English Revision Class, I learned many practical teaching techniques. My students found the lessons easier to understand, and classroom interaction improved. It also gave me more confidence in my teaching.",
  },
  {
    name: "Huang Xue Mei",
    role: "Parent",
    stars: 5,
    text: "After hearing about the SCS revision class, I registered my child and even joined the first lesson. The teacher made it fun and easy to understand, and my child stayed focused throughout. I am very happy to see the improvement in exam results.",
  },
  {
    name: "Daniel",
    role: "Student",
    stars: 5,
    text: "Thank you to SCS Education for preparing the SPM Revision Materials. They have helped me a lot with my revision and made it easier for me to know what topics to focus on. I also really appreciate the guidance from SCS on scholarships and course selection before SPM. It helped me understand my options early and know what I should study and prepare for.",
  },
];

export const FAQS = [
  {
    q: "Are the SPM revision notes and materials free?",
    a: " Yes! All revision notes, exam tips and learning materials provided are 100% free.",
  },
  {
    q: "Do I have to register for all 7 subjects?",
    a: "No. You can choose the subject(s) you are interested in.",
  },
  {
    q: "Is this a live class?",
    a: "No. This is not a live class. It is an online revision resources where students can access notes, exam tips and recorded teacher guidance videos through the online learning portal.",
  },
  {
    q: "Can I access the learning materials anytime?",
    a: "Yes. You can access the available notes and recorded lessons through the online learning portal at your convenience.",
  },
  {
    q: "What will the recorded videos teach?",
    a: "The recorded videos will guide students on how to use the revision notes, how to revise more effectively, what to focus on and how to approach questions to score more marks.",
  },
];

export const SUBJECT_LIST = SUBJECTS.map((s) => s.name);

export const WA_LANG = [
  {
    label: "Bahasa Melayu/ English",
    name: "BM/BI",
  },
  {
    label: "Chinese/ English",
    name: "BC/BI",
  },
];
